import { invalidateNavigationCache } from "~/Header/redux/loadNavigationEpic";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import { DEBUG_LANGUAGE_STORAGE_KEY } from "~/utils/language/isDebugLanguageEnabled";
import {
  LOGOUT_SUCCESS_KEY,
  markLogoutSuccessful
} from "~/Login/loginUtils";
import {clearRedirectionInfo, REDIRECT_TO_PRODUCT, setUpLoginPopUp} from "~/utils/redirectionUtil";

export const doLogout = (reloadPage = true, switchUser = false) => {
  const postLogout = () => {
    if(switchUser){
      setUpLoginPopUp();
    } else {
      clearRedirectionInfo();
    }
    reloadPage && window.location.reload();
  };
  invalidateNavigationCache();
  clearSessionStorage();
  return fetch(resolveApiUrl("/logout"))
    .then(() => markLogoutSuccessful())
    .finally(postLogout);
};

function clearSessionStorage() {
  const keysToPreserve = [DEBUG_LANGUAGE_STORAGE_KEY, LOGOUT_SUCCESS_KEY, REDIRECT_TO_PRODUCT];
  const dataToPreserve = keysToPreserve.reduce((acc, key) => {
    const value = window.sessionStorage.getItem(key);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, string>);
  window.sessionStorage.clear();
  Object.entries(dataToPreserve).forEach(([key, value]) => {
    window.sessionStorage.setItem(key, value);
  });
}
